// extracted by mini-css-extract-plugin
module.exports = {"container":"_2k2bUEJKYNbOoQeGBgb542","head":"_2uA1TtnipCmPGiJJMc-V1w","avatar":"_2OYiWrSwcBsO6Z2VGrjvOk","title":"_3k9JOwacRqPLa6JHv6del7","foot":"_2NDaV7g_qA0cKO01LYZacy"};